import Link from "next/link";

export default function SignoutOidc() {
  return (<>
    <h1>Signed Out</h1>
    <Link href='/?from=idella'>
      <a>Home</a>
    </Link>
    {/* <a href={process.env.NEXTAUTH_URL + '?from=idella'}>Home</a> */}
  </>)
}
